import { render, staticRenderFns } from "./AddPointsSetPoints.vue?vue&type=template&id=9dcdada8&scoped=true&"
import script from "./AddPointsSetPoints.vue?vue&type=script&lang=js&"
export * from "./AddPointsSetPoints.vue?vue&type=script&lang=js&"
import style0 from "./AddPointsSetPoints.vue?vue&type=style&index=0&id=9dcdada8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dcdada8",
  null
  
)

export default component.exports